const globalCSS = `
@layer theme, base, mui, components, utilities;

::-moz-selection { background: var(--tuna-palette-action-selected); }
::selection { background: var(--tuna-palette-action-selected); }

body, html {
  background-color: var(--tuna-palette-background-default);
  --background-color: var(--tuna-palette-background-default);
  font-family: var(--tuna-typography-fontFamily);
}

h1, h2, h3, h4, h5, h6 {
  color: var(--tuna-palette-text-primary);
}

p {
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: var(--tuna-typography-body1-fontWeight);
  line-height: var(--tuna-typography-body1-lineHeight);
  letter-spacing: var(--tuna-typography-body1-letterSpacing);
}

h1 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 36px;
}
@media (max-width: 599.95px) { h1 { font-size: 24px; } }
@media (max-width: 899.95px) { h1 { font-size: 28px; } }
@media (min-width: 1200px) { h1 { font-size: 40px; } }

h2 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 28px;
}
@media (max-width: 899.95px) { h2 { font-size: 24px; } }
@media (min-width: 1200px) { h2 { font-size: 30px; } }

h3 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 22px;
}
@media (max-width: 899.95px) { h3 { font-size: 20px; } }
@media (min-width: 1200px) { h3 { font-size: 24px; } }

h4 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 20px;
}
@media (max-width: 899.95px) { h4 { font-size: 18px; } }
@media (min-width: 1200px) { h4 { font-size: 24px; } }

h5 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 20px;
}
@media (max-width: 899.95px) { h5 { font-size: 18px; } }
@media (min-width: 1200px) { h5 { font-size: 22px; } }

h6 {
  margin-top: 8px;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 18px;
}
@media (max-width: 899.95px) { h6 { font-size: 16px; } }
@media (min-width: 1200px) { h6 { font-size: 20px; } }
`

export const TunaGlobalStyles = () => <style dangerouslySetInnerHTML={{ __html: globalCSS }} />

export default TunaGlobalStyles
